import React, { ReactNode } from 'react'
import Modal from '../Modal/Modal'

interface ConfirmationModalProps {
  isOpen: boolean
  onClose: () => void
  bodyContent: ReactNode
  footerContent?: ReactNode
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  bodyContent,
  footerContent,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header="Confirm Delete"
      body={bodyContent}
      footer={footerContent}
    />
  )
}

export default ConfirmationModal
